import { Badge } from '@procureai/uix';
import type { CustomCellRendererProps } from 'ag-grid-react';

import type { SavingsListQuery } from '@/generated/gql/graphql';

type SavingsListRow = SavingsListQuery['savings'][number];

export const SourceReferencesCellRenderer = ({ data }: CustomCellRendererProps<SavingsListRow>) => {
  const references = data?.sourceReferences ?? [];

  if (references.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {references.map((reference) => {
        const label = reference.sourceReferenceItem
          ? `${reference.sourceReference} / ${reference.sourceReferenceItem}`
          : reference.sourceReference;

        return (
          <Badge
            key={`${reference.fkSourceSystem}-${reference.sourceReference}-${reference.sourceReferenceItem ?? ''}`}
            variant="outline"
          >
            {`${reference.fkSourceSystem}: ${label}`}
          </Badge>
        );
      })}
    </div>
  );
};
